import { render, staticRenderFns } from "./TwoColumnInfo.vue?vue&type=template&id=fc05ae7c&scoped=true"
import script from "./TwoColumnInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoColumnInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TwoColumnInfo.vue?vue&type=style&index=0&id=fc05ae7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc05ae7c",
  null
  
)

export default component.exports